import * as React from "react";
const GoToIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M7.5 5.283c0-.46.372-.834.833-.834h6.666c.46 0 .834.373.834.834v6.666a.833.833 0 1 1-1.667 0V7.294l-8.577 8.578a.833.833 0 0 1-1.179-1.179l8.578-8.577H8.332a.833.833 0 0 1-.834-.833Z"
      clipRule="evenodd"
    />
  </svg>
);
export default GoToIcon;
